<template>
  <div>
    <vs-card>

      <b-row>
        <b-col>
          <b-row align-h="start">
            <b-col cols="12" md="auto"><b-form-input v-model="searching" @keyup.enter="getStockList()" id="smallInput"
                placeholder="Ara" />
            </b-col>
            <b-col cols="12" md="auto">
              <b-button style="  border-color:white !important;" v-on:click="getStockList()" id="loading-stockList2"
                class="bg-primary-gradient vs-con-loading__container">
                <Icon icon="clarity:search-line" width="20" height="20" v-b-tooltip.hover.bottom="'Listele/Ara'" />
              </b-button>
            </b-col>
            <b-col cols="12" md="auto">
              <b-row>
                Açılan Stoklar
                <br />
                <vs-switch style="border-radius: 25px" v-model="sendedStock" @change="getStockList()" vs-icon="done" />
              </b-row>
            </b-col>
            <!--
            <b-col cols="3" md="auto">
              <b-col>
                <v-select v-model="filteredMarketplace" placeholder="Pazaryeri Seçiniz" label="name" @input="getStockList"
                  :options="marketplaces" />
              </b-col>
            </b-col>-->
          </b-row>
        </b-col>
        <b-col>
          <b-row align-h="end">
            <b-col cols="12" md="auto">
              <TopluIslemComponent :secilenStok="selectedStock" />

            </b-col>
            <b-col cols="12" md="auto">
              <!--   <ExcelYazdirButon :excelData="generalStock" />-->

            </b-col>
          </b-row>
        </b-col>



      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine"
        :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="stockList" :localeText="localeText"
        @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection"
        @selection-changed="onSelectionChanged" @filter-changed="onFilterChanged" :suppressCopyRowsToClipboard="true">
      </ag-grid-vue>
      {{ generalStockCount }}
      <b-pagination :value="1" :total-rows="totalStock" :per-page="pageLength" first-number last-number pills
        prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" v-model="currentPage" @input="getStockList()">
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>

          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
      <div class="d-flex align-items-center mb-0 mt-1">{{ totalStock }} adet kayıttan
        <span class="text-nowrap"> Gösterilen kayıt </span>
        <b-form-select v-model="pageLength" :options="['50', '100', '250', '500', '1000']" class="mx-1" v-on:change="
              getStockList()
              " />
      </div>
    </vs-card>
    <StokListesiDetay :isPromptActiveStockDetail="stockDetailPopupActive" :data="stockDetailData"
      @closeStockPopup="toggleData" />
    <StokListesiFiyatGuncelle :is-active="stockPriceUpdatePopupActive" :data="stockPriceUpdateData"
      @closePriceUpdatePopup="togglePriceUpdate" />
  </div>
</template>
<script>
import vSelect from "vue-select";
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import StokListesiDetay from "./StokListesiDetay.vue";
import StokListesiFiyatGuncelle from "./StokListesiFiyatGuncelle.vue";
import TopluIslemComponent from "../components/uzum-components/stoklistesi-components/TopluIslemComponent.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import StockListesiButonsCellRenderer from "./CellRenderers/StockListesiButonsCellRenderer.vue";
//import ExcelYazdirButon from "../components/uzum-components/stoklistesi-components/ExcelYazdirButon.vue";
import StockListesiPazaryeriGorunumCellRenderer from "./CellRenderers/StockListesiPazaryeriGorunumCellRenderer.vue";
export default {
  components: {
    vSelect,
    //ExcelYazdirButon,
    TopluIslemComponent,
    StokListesiDetay,
    StokListesiFiyatGuncelle,
    AgGridVue,
    Icon,
    TextGorunumCellRenderer,
    StockListesiButonsCellRenderer,
    StockListesiPazaryeriGorunumCellRenderer
  },
  data() {
    return {
      marketplaces: [],
      filteredMarketplace: "",
      generalStock: [],
      generalStockCount: "",
      rowSelection: null,
      selectedStock: [],
      stockDetailData: [],
      stockDetailPopupActive: false,
      stockPriceUpdateData: [],
      stockPriceUpdatePopupActive: false,
      pageLength: 50,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      columnDefs: null,
      localeText: null,
      stockList: null,
      searching: "",
      sendedStock: false,
      totalStock: 0,
      currentPage: 1
    };
  },
  methods: {
    onFilterChanged() {
      try {
        this.generalStockCount = this.gridApi.getDisplayedRowCount();
      } catch (error) {
        console.log(error)
      }

    },
    onSelectionChanged() {
      this.selectedStock = this.gridApi.getSelectedRows();
    },
    toggleData(val = false) {
      this.stockDetailPopupActive = val;
    },
    togglePriceUpdate(val = false) {
      this.stockPriceUpdatePopupActive = val;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      // params.api.sizeColumnsToFit();
    },
    getStockDetail() { },
    getStockList() {
      var vm = this;
      var vs = this.$vs;
      let type = "radius";



      let barcodeChildren = [
        {
          pinned: "left",
          width: 200,
          field: "Barkod",
          sortable: true,
          filter: "agSetColumnFilter"
        }
      ];
      let categoryChildren = [
        {
          width: 200,
          field: "kategori3",
          sortable: true,
          filter: "agSetColumnFilter",
          pinned: "left",

        }
      ];
      let spaceChildren = [
        {
          width: 200,
          field: "alan1",
          sortable: true,
          filter: "agSetColumnFilter"
        }
      ];
      const soap = require("soap");
      const url = state.sistemAddress;
      let searcedMarketplace = "";
      if (vm.sendedStock === true) {
        searcedMarketplace =
          ' and Pazaryeri != \'[{"program":"Gönderilmemis"}]\' ';
      } else {
        searcedMarketplace = vm.filteredMarketplace.name
      }

      const args = {
        token: Store.state.tokenId,
        kod: vm.searching,
        AktifPazarYeriTanim: searcedMarketplace,
        pageSize: vm.pageLength,
        page: vm.searching != "" ? 1 : vm.currentPage,
      };
      soap.createClient(url, function (err, client) {
        vs.loading({
          container: "#loading-stockList2",
          type
        });

        client.stokListesi(args, function (err, result) {
          if (result.stokListesiResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vs.loading.close("#loading-stockList2 > .con-vs-loading");
            vm.veriler = JSON.parse(result.stokListesiResult);

            console.log(vm.veriler)

            vm.columnDefs = [];

            vm.totalStock = vm.veriler[0].kayitSayisi;
            vm.columnDefs.push({
              headerCheckboxSelection: true,
              checkboxSelection: true,
              showDisabledCheckboxes: true,
              width: 220,
              pinned: "left",
              filter: "agSetColumnFilter",
              cellRenderer: "StockListesiButonsCellRenderer"
            });
            let list = vm.veriler;
            let columnList = Object.keys(list[0]);
            columnList.forEach((val, index) => {
              if (val.includes("Barkod")) {
                if (val != "Barkod")
                  barcodeChildren.push({
                    pinned: "left",

                    width: 100,
                    field: val,
                    autoHeight: true,
                    columnGroupShow: "open",

                    filter: "agSetColumnFilter"
                  });
              } else if (val.includes("kategori")) {
                if (val != "kategori3")
                  categoryChildren.push({
                    pinned: "left",
                    width: 100,
                    field: val,
                    autoHeight: true,
                    columnGroupShow: "open",
                    filter: "agSetColumnFilter"
                  });
              } else if (val.includes("alan")) {
                if (val != "alan1")
                  spaceChildren.push({
                    width: 100,
                    field: val,
                    autoHeight: true,
                    columnGroupShow: "open",
                    filter: "agSetColumnFilter"
                  });
              } else if (val.includes("pazaryeri")) {
                vm.columnDefs.push({
                  width: 100,

                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                  cellRenderer: "StockListesiPazaryeriGorunumCellRenderer"
                });
              } else if (
                val.includes("StokAdi") ||
                val.includes("stokKodu")
              ) {
                vm.columnDefs.push({
                  width: 100,

                  pinned: "left",
                  field: val,
                  filter: "agSetColumnFilter",
                  cellRenderer: "TextGorunumCellRenderer",
                  wrapText: true,
                  autoHeight: true
                });
              } else if (!val.includes("Page") && !val.includes("kayit")) {
                vm.columnDefs.push({
                  field: val,
                  filter: "agSetColumnFilter"
                });
              }
            });
            vm.columnDefs.push({
              headerName: "Barkod",

              children: barcodeChildren
            });
            vm.columnDefs.push({
              headerName: "Kategori",
              children: categoryChildren
            });
            vm.columnDefs.push({
              headerName: "Alan",
              children: spaceChildren
            });
            vm.stockList = list;
            vm.generalStock = list
            vm.generalStockCount = list.length
            //  vm.KAYITSAYISI = vm.liste.length;

          } catch (error) {
            vs.loading.close("#loading-stockList2 > .con-vs-loading");

            vs.notify({
              title: "Stok Listesi",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center"
            });
          }
        });
      });
    }
  },
  mounted() {
    this.$root.$on("getStockListDetail", data => {
      this.stockDetailData = data;
      this.stockDetailPopupActive = true;
    });
    this.$root.$on("getStockPriceUpdate", data => {
      this.stockPriceUpdateData = data;
      this.stockPriceUpdatePopupActive = true;
    });
    this.$root.$on("getStockList", () => {
      this.getStockList();
    });
  },
  beforeDestroy() {
    this.$root.$off("getStockListDetail");
    this.$root.$off("getStockPriceUpdate");
    this.$root.$off("getStockList");

  },
  created() {
    this.marketplaces = [];
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.getStockList();
    this.rowSelection = 'multiple';
    let moduller = JSON.parse(Store.state.moduller)
    console.log(moduller)
    moduller.forEach((val, index) => {
      this.marketplaces.push({ name: val.marketplace })
    });
  }
};
</script>
